import "../assets/styles/base/variables.scss"

export const theme = {
  token: {
    colorPrimary: "#1FA9FF",
    colorLink: "#1F39FF",
    colorFillContent: "#000",
    colorTextPlaceholder: "#395263"
  },
};
